import { c as _c } from "react/compiler-runtime";
import { Button } from "@website/ui/button";
import { useCounterButton } from "@website/ui/counter-button/counter-button.hook";
import styles from "@website/ui/counter-button/counter-button.module.scss";
import { CounterButtonPropertiesType } from "@website/ui/counter-button/counter-button.types";
import { FC } from "react";
export const CounterButton: FC<CounterButtonPropertiesType> = properties => {
  const $ = _c(23);
  const {
    className,
    variant,
    decreaseDisabled,
    increaseDisabled,
    helperText,
    error,
    size: t0
  } = properties;
  const size = t0 === undefined ? "medium" : t0;
  const {
    value,
    rootProps,
    decreaseButtonProps,
    increaseButtonProps,
    valueProps
  } = useCounterButton(properties);
  const t1 = `${styles["counter-button"]} ${styles[variant ?? "contained"]} ${className ?? ""}`;
  let t2;
  if ($[0] !== increaseButtonProps || $[1] !== size) {
    t2 = <Button {...increaseButtonProps} size={size} type="button" />;
    $[0] = increaseButtonProps;
    $[1] = size;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== value || $[4] !== valueProps) {
    t3 = <div {...valueProps} className={styles.value}>{value}</div>;
    $[3] = value;
    $[4] = valueProps;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== decreaseButtonProps || $[7] !== size) {
    t4 = <Button {...decreaseButtonProps} size={size} type="button" />;
    $[6] = decreaseButtonProps;
    $[7] = size;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== rootProps || $[10] !== t1 || $[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = <div {...rootProps} className={t1}>{t2}{t3}{t4}</div>;
    $[9] = rootProps;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== decreaseDisabled || $[16] !== error || $[17] !== helperText || $[18] !== increaseDisabled) {
    t6 = helperText ? <div className={`${styles["helper-text"]} ${decreaseDisabled && increaseDisabled && styles.disabled} ${error && styles.error}`}>{helperText}</div> : null;
    $[15] = decreaseDisabled;
    $[16] = error;
    $[17] = helperText;
    $[18] = increaseDisabled;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t5 || $[21] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
};